// for after PASS auth
const RETURN_URL = 'https://allbirds.co.kr/pages/kakao-signup';
const ERROR_URL = 'https://allbirds.co.kr/404';
let authObj;
let enc_data;
let popup;
let intervalId = null;

const dataFirstName = document.querySelector('[data-firstName]');
const dataLastName = document.querySelector('[data-lastName]');
const dataPhoneNumber = document.querySelector('[data-phoneNumber]');
const dataCustomerEmail = document.querySelector('[data-customerEmail]');

// check over 14 years
const validateYearConfirmation = (year, month, day) => {
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth();
  const currentDay = today.getDate();

  // 만 14세가 되는 날짜
  const fourteenYearsAgo = new Date(currentYear - 14, currentMonth, currentDay);

  // birthday
  const birthDate = new Date(Number(year), Number(month) -1, Number(day));

  // validate
  const isOver14 = birthDate <= fourteenYearsAgo;
  return isOver14
}

// check customer exist
const checkShopifyUser = async ({email, phone}) => {
  let url = 'https://allbirds-live.lukuku.co/api/check-user/kakao?'
  const params = new URLSearchParams();

  if (email) params.append('email', email);
  if (phone) params.append('phone', phone);
  url += params.toString();

  try {
    return await fetch(url, {
      method: 'GET'
    })
    .then(response => response.json())
    .catch(error => {
      console.log('Error:', error)
    })
  } catch(err) {
    console.log("Error:", err)
  }
}

const requestSocialLogin = async (payload) => {
  const url = 'https://allbirds-live.lukuku.co/api/social/login/extra-info';

  return await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload)
  })
  .then(response => response.json())
  .then(data => {
    if (data.isLogin === 'success') {
      sessionStorage.removeItem('sns-auth');
      window.location.href = `/account/login/multipass/${data.token}`;
    } else {
      console.log(data)
      alert("문제가 발생했습니다. 관리자에게 문의해주세요.")
    }
  })
  .catch(err => console.error(err))
}

const getEncData = async (return_url, error_url) => {
  return await fetch(`https://allbirds-live.lukuku.co/api/pass/checkplus_main?error_url=${error_url}&return_url=${return_url}`, {
      method: 'GET'
    })
    .then(response => response.json())
    .then(data => {
      const encodeData = data.result.enc_data
      document.querySelector('[data-encoded]').value = encodeData;
      enc_data = encodeData
      return encodeData
    })
    .catch(error => {
      console.log('Error:', error);
    })
}

const getDecData = async (encodeData) => {
  try{
    const data = await fetch(`https://allbirds-live.lukuku.co/api/pass/checkplus_success`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        encodeData: encodeData
      })
    })
    .then(response => response.json())
    .catch(error => {
      console.log('Error:', error);
    })
    return data
  }catch(err) {
    console.log('Error:', err)
  }
}


function isMobileDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // is Mobile or not
  return /android|avantgo|blackberry|bada|bb|blazer|compal|elaine|fennec|hiptop|iemobile|iphone|ipod|iris|kindle|maemo|midp|minimo|mobi|mobile|opera mini|palm|phone|p(ixi|re)\/|plucker|pocket|psp|symbian|treo|up\.browser|up\.link|vodafone|wap|windows ce|xda|xiino/i.test(userAgent);
}

function fnPopup2(){
  if (enc_data){
    if (isMobileDevice()) {
      document.form_chk.action = "https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb";
      document.form_chk.submit();
    } else {
      window.open('', 'popupChk', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no');
      document.form_chk.action = "https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb";
      document.form_chk.target = "popupChk";
      document.form_chk.submit();
    }

    clearInterval(intervalId);
  } else {
    console.log("enc_data is not set yet.")
  }
}

function fnRequestPass() {
  const urlParams = new URLSearchParams(window.location.search);
  const EncodeData = urlParams.get('EncodeData');

  if (EncodeData) return;
  alert("카카오 회원가입을 추가정보 수집을 위해 본인인증을 진행합니다.");
  intervalId = setInterval(fnPopup2, 1000);
}


function receiveRedirectUrl(redirectUrl) {
  window.location.href = redirectUrl
}

// Get from pass
function sendRedirectUrlToParent(EncodeData) {
  const url = `/pages/kakao-signup?EncodeData=${encodeURIComponent(EncodeData)}`
  if (window.opener && typeof window.opener.receiveRedirectUrl === 'function') {
    window.opener.receiveRedirectUrl(url);
  }
  window.close();
}

document.addEventListener('DOMContentLoaded', function () {
  if (window.opener) {
    const urlParams = new URLSearchParams(window.location.search);
    const EncodeData = urlParams.get('EncodeData')
    sendRedirectUrlToParent(EncodeData);
  }
});

// phone number condition
document.addEventListener('DOMContentLoaded', function () {
  var phoneNumberFields = document.querySelectorAll('[data-phoneNumber]');
  phoneNumberFields.forEach(function (field) {
    field.addEventListener('keypress', function (e) {
      var charCode = e.which || e.keyCode;
      var char = String.fromCharCode(charCode);
      if (/[^0-9]/.test(char)) {
        e.preventDefault();
      }
    });
  });
});

// Get the value of phonenumber
const phoneNumberInput = document.querySelector('[data-phoneNumber]');
const hiddenInput = document.querySelector('[data-phoneNumberHidden]');
phoneNumberInput.addEventListener('input', function () {
  const phoneNumber = this.value;
  hiddenInput.value = phoneNumber;
});

// Add condition of the email
const emailInput = document.querySelector('[data-customerEmail]');
// Function to validate email
function validateEmail(emailValue) {
  const registerEmail = document.querySelector('[data-registerEmail]');
  if (emailValue && !emailValue.includes('.')) {
    registerEmail.classList.add('main-register__customerEmail--error');
    return false;
  } else {
    registerEmail.classList.remove('main-register__customerEmail--error');
    return true;
  }
}

// Bind submit event to the form
document.addEventListener('DOMContentLoaded', function () {
  var createCustomerForm = document.getElementById('create_customer');
  if (createCustomerForm && emailInput) {
    createCustomerForm.addEventListener('submit', function (event) {
      var emailValue = emailInput.value;
      if (!validateEmail(emailValue)) {
        event.preventDefault();
      }
    });
  }
});

// Bind mouseleave event to the email input field
document.addEventListener('DOMContentLoaded', function () {
  if (emailInput) {
    emailInput.addEventListener('mouseleave', function () {
      var emailValue = emailInput.value;
      validateEmail(emailValue);
    });
  }
});

// enable form button if the input value filled
var getYear = document.querySelector('[data-birthYear]');
var currentYear = new Date().getFullYear();

// Create the first option for "연도" with attributes disabled and selected
var firstOption = document.createElement('option');
firstOption.text = '연도';
firstOption.disabled = true;
firstOption.selected = true;
getYear.appendChild(firstOption);

// Loop through the years to create options for each year
for (var i = 1900; i <= currentYear; i++) {
  var option = document.createElement('option');
  option.innerHTML = i;
  option.value = i;
  getYear.appendChild(option);
}

let year = document.querySelector('[data-birthYear]').value;
let month = document.querySelector('[data-birthMonth]').value;
let day = document.querySelector('[data-birthDay]').value;
let birthday = `${year}/${month}/${day}`;
// Function to update the data-customerTagBirthdayHidden value attribute
document.querySelectorAll('[data-birthSelect]').forEach((element) => {
  element.addEventListener('change', () => {
    if (element.getAttribute('name') == 'year') {
      year = element.value;
    } else if (element.getAttribute('name') == 'month') {
      month = element.value;
    } else if (element.getAttribute('name') == 'day') {
      day = element.value;
    }
    birthday = `${year}/${month}/${day}`;
    document.querySelector('[data-birthDayInputValue]').value = birthday;
  });
});

// check the all value then add class from the button
const submitButton = document.querySelector('input[type="submit"]');
const dataBirthYear = document.querySelector('[data-birthYear]');
const dataBirthMonth = document.querySelector('[data-birthMonth]');
const dataBirthDay = document.querySelector('[data-birthDay]');
const dataHiddenBirthDay = document.querySelector('[data-birthDayInputValue]');
let birthYearChanged = false;
let birthMonthChanged = false;
let birthDayChanged = false;

function checkAllInputs() {
  const allInputs = [
    dataFirstName,
    dataLastName,
    dataPhoneNumber,
    dataCustomerEmail
  ];
  for (const input of allInputs) {
    if (!input.value.trim()) {
      return false;
    }
  }
  // validation
  if (!validateEmail(dataCustomerEmail.value)) {
    return false;
  }
  return true;
}

function updateSubmitButton() {
  if (checkAllInputs()) {
    submitButton.classList.remove('main-register__disabledButton');
  } else {
    submitButton.classList.add('main-register__disabledButton');
  }
}

// Listen for input events on all inputs except birth year, month, and day
dataFirstName.addEventListener('input', updateSubmitButton);
dataLastName.addEventListener('input', updateSubmitButton);
dataPhoneNumber.addEventListener('input', updateSubmitButton);
dataCustomerEmail.addEventListener('input', updateSubmitButton);

// Click event for pass
dataFirstName.addEventListener('click', fnRequestPass);
dataLastName.addEventListener('click', fnRequestPass);
dataPhoneNumber.addEventListener('click', fnRequestPass);
dataBirthYear.addEventListener('click', fnRequestPass);
dataBirthMonth.addEventListener('click', fnRequestPass);
dataBirthDay.addEventListener('click', fnRequestPass);

// Listen for change events on birth year, month, and day
dataBirthYear.addEventListener('change', function () {
  birthYearChanged = true;
  updateSubmitButton();
});

dataBirthMonth.addEventListener('change', function () {
  birthMonthChanged = true;
  updateSubmitButton();
});

dataBirthDay.addEventListener('change', function () {
  birthDayChanged = true;
  updateSubmitButton();
});

// Initial check
document.addEventListener("DOMContentLoaded", function () {
  updateSubmitButton();
})


// About modal
document.addEventListener('click', function (event) {
  var registerPopup = document.querySelectorAll('[data-registerPopup]');
  var innerDiv = document.querySelector('[data-inner-register-popup]');

  var isClickInsideInnerDiv = innerDiv && innerDiv.contains(event.target);
  var isIconRemoveClicked = event.target.hasAttribute('data-registerIconRemove');
  var isRegisterLinkClicked = event.target.hasAttribute('data-register-link');
  var isRedirectIconRemoveClicked = event.target.hasAttribute('data-redirect-registerIconRemove');

  if (isIconRemoveClicked || isRegisterLinkClicked) {
    registerPopup.forEach((element) => element.classList.remove('sm-register__popup--active'));
    document.body.classList.remove('register-popup-active');
  }
  if (isRedirectIconRemoveClicked) {
    window.location.href = '/account/login';
  }
});

// value come from the pass
document.addEventListener("DOMContentLoaded", async function() {
  const urlParams = new URLSearchParams(window.location.search);
  const EncodeData = urlParams.get('EncodeData')

  authObj = JSON.parse(sessionStorage.getItem('sns-auth'));
  const { 
    kakaoEmail, 
  } = authObj;

  if (EncodeData) {
    const { result } = await getDecData(EncodeData);
    if (result.birthdate) {
      const yearValue = result.birthdate.substring(0, 4)
      const monthValue = result.birthdate.substring(4, 6)
      const dayValue = parseInt(result.birthdate.substring(6))
      const inputValue = `${yearValue}/${monthValue}/${dayValue < 10 ? '0' + dayValue: dayValue}`

      // Validation over 14 year
      const isOver14 = validateYearConfirmation(yearValue, monthValue, dayValue);
      const yearPopup = document.querySelector('[data-year-registerPopup]');
      if (yearPopup) {
        if (!isOver14) {
          yearPopup.classList.add('sm-register__popup--active');
        }
      }
      dataBirthYear.value = yearValue;
      dataBirthMonth.value = monthValue;
      dataBirthDay.value = dayValue;
      dataHiddenBirthDay.value = inputValue;
    }

    if (result.mobileno) {
      const mobile = result.mobileno;
      // check duplicated phone number
      const response = await checkShopifyUser({email: '', phone: mobile});
      if (response.userExist) {
        const phonePopup = document.querySelector('[data-phone-registerPopup]');
        if (phonePopup) {
          phonePopup.classList.add('sm-register__popup--active');
        }
      }
      const formattedMobile = mobile.substring(0,3) + "-" + mobile.substring(3,7) + "-" + mobile.substring(7);
      dataPhoneNumber.value = formattedMobile;
    }

    if (result.name) {
      dataLastName.value = result.name.charAt(0);
      dataFirstName.value = result.name.slice(1);
    }

    if (kakaoEmail) {
      dataCustomerEmail.value = kakaoEmail;
    }
    updateSubmitButton();
  }
})

// value come from the sessionStorage
document.addEventListener('DOMContentLoaded', async function () {
  const urlParams = new URLSearchParams(window.location.search);
  const EncodeData = urlParams.get('EncodeData');
  authObj = JSON.parse(sessionStorage.getItem('sns-auth'));
  const { 
    birthday,  
    firstName,
    kakaoEmail, 
    lastName, 
    phoneNumber, 
    gender,
  } = authObj;

  await getEncData(RETURN_URL, ERROR_URL);

  if (EncodeData) return;

  var selectElements = document.querySelectorAll('select[readonly]');
  selectElements.forEach(function (selectElement) {
    var options = selectElement.options;
    for (var i = 0; i < options.length; i++) {
      options[i].disabled = true;
    }
  });

  if (kakaoEmail) {
    dataCustomerEmail.value = kakaoEmail;
  }
  if (firstName) {
    dataFirstName.value = firstName;
  }
  if (lastName) {
    dataLastName.value = lastName;
  }
  if (phoneNumber) {
    const response = await checkShopifyUser({email: '', phone: phoneNumber});
    if (response.userExist) {
      const phonePopup = document.querySelector('[data-phone-registerPopup]');
      if (phonePopup) {
        phonePopup.classList.add('sm-register__popup--active');
      }
    }
    dataPhoneNumber.value = phoneNumber;
  }
  if (birthday) {
    const yearValue = birthday.split("/")[0];
    const monthValue = birthday.split("/")[1];
    const dayValue = birthday.split("/")[2];
    dataBirthYear.value = yearValue;
    dataBirthMonth.value = monthValue;
    dataBirthDay.value = dayValue;
    dataHiddenBirthDay.value = birthday;

    // Validation over 14 year
    const isOver14 = validateYearConfirmation(yearValue, monthValue, dayValue);
    const yearPopup = document.querySelector('[data-year-registerPopup]');
    if (yearPopup) {
      if (!isOver14) {
        yearPopup.classList.add('sm-register__popup--active');
      }
    }
  }
  // 위 조건 만족시 PASS 인증 진행
  if (birthday === "" || phoneNumber === "" || firstName === "" || lastName === "") {
    fnRequestPass();
  }
  updateSubmitButton();
});

const submit = async () => {

  const { 
    createdAt,  
    emailMarketingTerms,
    kakaoEmail, 
    smsMarketingTerms, 
    returnTo, 
    gender,
  } = authObj;

  const response = await checkShopifyUser({email: dataCustomerEmail.value, phone: ''})
  if (response.userExist) {

    if (response.userState === 'enabled') {
      var registerPopup = document.querySelector('[data-email-registerPopup]');
      if (registerPopup) {
        registerPopup.classList.add('sm-register__popup--active');
      }
      document.body.classList.add('register-popup-active');
    } else {
      var registerPopup = document.querySelector('[data-disabled-email-registerPopup]');
      if (registerPopup) {
        registerPopup.classList.add('sm-register__popup--active');
      }
      document.body.classList.add('register-popup-active');
    }
    
    return;
  } 

  const payload = {
    shopifyEmail: dataCustomerEmail.value,
    firstName: dataFirstName.value,
    lastName: dataLastName.value,
    phoneNumber: dataPhoneNumber.value.replace(/-/g, ''),
    birthday: dataHiddenBirthDay.value,
    createdAt: createdAt,
    emailMarketingTerms: emailMarketingTerms,
    kakaoEmail: kakaoEmail,
    smsMarketingTerms: smsMarketingTerms,
    returnTo: returnTo,
    gender: gender,
  }
  await requestSocialLogin(payload);
}

document.addEventListener("DOMContentLoaded", () => {
  submitButton.addEventListener("click", async () => {
    await submit();
  })
})